import React, { useMemo } from 'react';
import { AMPEL_FRIST, formatDatum, fristAmpel, fristKategorieLabel, sortiereFristen } from '../../../services/sifa/kundenportalLogic';
import type { KundenportalDaten } from '../../../services/sifa/kundenportalTypes';
import { HINWEISKASTEN } from '../public/teilnahmeSeiteStil';

/** Offene Fristen des Betriebs mit Ampel — nur lesen; erledigt meldet die SiFa. */
export const FristenTab: React.FC<{ daten: KundenportalDaten }> = ({ daten }) => {
  const fristen = useMemo(() => sortiereFristen(daten.fristen), [daten.fristen]);

  if (fristen.length === 0) {
    return <div className={HINWEISKASTEN}>Derzeit sind keine offenen Fristen hinterlegt.</div>;
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-500">
        Prüfungen, Vorsorge, Sitzungen und Wiederholungen, die Ihre Fachkraft für Arbeitssicherheit für Ihren Betrieb führt.
        Rot = überfällig, gelb = in den nächsten 60 Tagen fällig.
      </p>
      <ul className="divide-y divide-slate-100 border border-slate-200 rounded-xl overflow-hidden">
        {fristen.map((f) => {
          const ampel = AMPEL_FRIST[fristAmpel(f.faelligAm)];
          return (
            <li key={f.id} className="p-3 flex items-start gap-3">
              <span className={`mt-1.5 w-3 h-3 rounded-full shrink-0 ${ampel.punkt}`} aria-hidden />
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-slate-800">{f.titel || fristKategorieLabel(f.kategorie)}</p>
                <p className="text-xs text-slate-500">
                  {fristKategorieLabel(f.kategorie)}
                  {f.intervallMonate ? ` · alle ${f.intervallMonate} Monate` : ''}
                  {f.zustaendig ? ` · zuständig: ${f.zustaendig}` : ''}
                </p>
                {f.notiz && <p className="text-xs text-slate-600 mt-1 whitespace-pre-line">{f.notiz}</p>}
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-bold text-slate-800">{formatDatum(f.faelligAm)}</p>
                <p className={`inline-flex px-2 py-0.5 text-[11px] font-bold border rounded-full ${ampel.klasse}`}>{ampel.label}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
